import { css } from '@emotion/react';

export default css({
    flexDirection: 'column',
    padding: '21px 0 3px 0',
    '.brief-card': {
        marginBottom: '18px',
    },
});
